<template>
    <label class="radio" @click.prevent="toggle">
        <input
            type="radio"
            :value="value"
            :checked="checked"
            :name="name"
            :required="required"
        >
        <div class="icon">
            <font-awesome-icon icon="circle" />
        </div>
        <slot />
    </label>
</template>

<script>
    export default {
        model: {
            prop: 'current',
            event: 'toggle',
        },
        props: {
            name: {
                required: false,
                type: String,
                default: null,
            },
            value: {
                required: true,
                type: [String, Number],
            },
            current: {
                required: true,
                type: String,
            },
            required: {
                type: Boolean,
                default: null,
            },
        },
        computed: {
            checked() {
                return this.value === this.current;
            },
        },
        methods: {
            toggle() {
                this.$emit('toggle', this.value);
            },
        },
    };
</script>